module.exports = __webpack_public_path__ + "static/media/profile.b1e9e626.jpg";